module.exports = __webpack_public_path__ + "img/four3Green.1279ce1a.jpg";